import { render, staticRenderFns } from "./CardReports.vue?vue&type=template&id=1539a745&"
import script from "./CardReports.vue?vue&type=script&lang=js&"
export * from "./CardReports.vue?vue&type=script&lang=js&"
import style0 from "./CardReports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports